import { Component } from "@angular/core";

@Component({
  selector: "app-monument-installation-request",
  templateUrl: "./monument-installation-request.component.html",
  standalone: false,
})
export class MonumentInstallationRequestComponent {}
